import { DetailedFooterWrapper, DataProps } from 'ui/navigation/components/detailed-footer-int';

const DetailedFooterIntTastic = ({ data }: DataProps) => {
  return <DetailedFooterWrapper data={data} />;
};

export default DetailedFooterIntTastic;
